<script>
    import {player, enemies, colors} from '../store';
    $: laserSets = [$player, ...$enemies].map(robot => robot.lasers);
</script>

{#each laserSets as lasers}
    {#each lasers as {origin, target}}
        <line x1="{origin.x}" y1="{origin.y}" x2="{target.x}" y2="{target.y}" stroke-width="0.1" stroke="{$colors.red[500]}" />
    {/each}
{/each}
